export const trimLeadingZeros = (sku?: string | null): string => {
    if (!sku) return '';
    const trimmed = sku.replace(/^0+/, '');
    return trimmed === '' ? '0' : trimmed;
};
